import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup.object({
  password_api: yup
    .string()
    .nullable()
    .trim()
    .label('New Password')
})

const resChangePassword = yupResolver(schema)

export default resChangePassword
